<template>
    <div class="container mb-5">
        <!-- <Breadcrumb class="bread_block" />  -->
        <CommonBreadcrumb class="bread_block" /> 
        <h1 class="mb-4 font-active">In the spotlight!</h1>
        <div class="press_block radious_eight">
            <picture>
                <source width="153" height="40" type="image/webp" srcset="~/assets/media/pr/forbes.webp">
                <img class="for_mobile radious_four" loading="lazy" width="153" height="40" type="image/jpeg"
                    src="~/assets/media/pr/forbes.jpg" alt="3 Key Sustainable Fashion Trends To Follow This Year">
            </picture>
            <div class="press_left">
                <picture>
                    <source width="451" height="300" type="image/webp" srcset="~/assets/media/forbes.webp">
                    <img loading="lazy" class="radious_four" type="image/jpeg" src="~/assets/media/forbes.jpg" width="451" height="300"
                        alt="3 Key Sustainable Fashion Trends To Follow This Year">
                </picture>
            </div>
            <div class="press_right">
                <div class="press_text">
                    <picture>
                        <source width="153" height="40" type="image/webp" srcset="~/assets/media/pr/forbes.webp">
                        <img class="for_desktop radious_four" loading="lazy" width="153" height="40" type="image/jpeg"
                            src="~/assets/media/pr/forbes.jpg"
                            alt="3 Key Sustainable Fashion Trends To Follow This Year">
                    </picture>
                    <h2 class="font-active">3 Key Sustainable Fashion Trends To Follow This Year</h2>
                    <p>Transform your style with a sustainable twist: Make conscious decisions to create a better
                        tomorrow by investing in brands that prioritize ethical and sustainable practices. Your tiny
                        shifts can help in bringing colossal impacts on the earth’s future.</p>
                    <a class="radious_four" href="https://www.forbes.com/sites/joanneshurvell/2022/06/23/3-key-sustainable-fashion-trends-to-follow-this-year/"
                        target="_blank" rel="nofollow noopener">
                        read more
                    </a>
                </div>
            </div>
        </div>
        <!-- <div class="press_block">
            <picture>
                <source width="162" height="40" type="image/webp" srcset="~/assets/media/pr/brides.webp">
                <img class="for_mobile" loading="lazy" width="162" height="40" type="image/jpeg"
                    src="~/assets/media/pr/brides.jpg"
                    alt="The 20 Best Lab-Grown Diamond Tennis Bracelets to Complement Your Bridal Style">
            </picture>
            <div class="press_left">
                <picture>
                    <source width="451" height="300" type="image/webp" srcset="~/assets/media/brides.webp">
                    <img loading="lazy" type="image/jpeg" src="~/assets/media/brides.jpg" width="451" height="300"
                        alt="The 20 Best Lab-Grown Diamond Tennis Bracelets to Complement Your Bridal Style">
                </picture>
            </div>
            <div class="press_right">
                <div class="press_text">
                    <picture>
                        <source width="162" height="40" type="image/webp" srcset="~/assets/media/pr/brides.webp">
                        <img class="for_desktop" loading="lazy" width="162" height="40" type="image/jpeg"
                            src="~/assets/media/pr/brides.jpg"
                            alt="The 20 Best Lab-Grown Diamond Tennis Bracelets to Complement Your Bridal Style">
                    </picture>
                    <h2 class="font-active">The 20 Best Lab-Grown Diamond Tennis Bracelets to Complement Your Bridal
                        Style</h2>
                    <p>Suggestions from the best for adding a touch of elegance & sophistication to your bridal look.
                        Let these stunning lab diamond tennis bracelets enhance your style and make a lasting impression
                        with their timeless beauty.</p>
                    <a href="https://www.brides.com/lab-grown-diamond-tennis-bracelet-5215874" target="_blank"
                        rel="nofollow noopener">
                        read more
                    </a>
                </div>
            </div>
        </div> -->
        <!-- <div class="press_block">
            <picture>
                <source width="156" height="40" type="image/webp" srcset="~/assets/media/pr/la_weekly.webp">
                <img class="for_mobile" loading="lazy" width="156" height="40" type="image/jpeg"
                    src="~/assets/media/pr/la_weekly.jpg" alt="A Dream Proposal With An Eco-Friendly Twist">
            </picture>
            <div class="press_left">
                <picture>
                    <source width="451" height="300" type="image/webp" srcset="~/assets/media/la_weekly.webp">
                    <img loading="lazy" type="image/jpeg" src="~/assets/media/la_weekly.jpg" width="451" height="300"
                        alt="A Dream Proposal With An Eco-Friendly Twist">
                </picture>
            </div>
            <div class="press_right">
                <div class="press_text">
                    <picture>
                        <source width="156" height="40" type="image/webp" srcset="~/assets/media/pr/la_weekly.webp">
                        <img class="for_desktop" loading="lazy" width="156" height="40" type="image/jpeg"
                            src="~/assets/media/pr/la_weekly.jpg" alt="A Dream Proposal With An Eco-Friendly Twist">
                    </picture>
                    <h2 class="font-active">A Dream Proposal With An Eco-Friendly Twist</h2>
                    <p>Celebrate a fairytale proposal that's as magical as ones written in the storybooks - John and
                        Tierney's beautiful love story, sealed with a promise of forever with a lab diamond ring that
                        embodies the real essence of their love.</p>
                    <a href="https://www.laweekly.com/a-dream-proposal-with-an-eco-friendly-twist/" target="_blank"
                        rel="nofollow noopener">
                        read more
                    </a>
                </div>
            </div>
        </div> -->
        <div class="press_block radious_eight">
            <picture>
                <source width="103" height="40" type="image/webp" srcset="~/assets/media/pr/ibt.webp">
                <img class="for_mobile radious_four" loading="lazy" width="103" height="40" type="image/jpeg"
                    src="~/assets/media/pr/ibt.jpg" alt="Sustainability At The Fore Of A Lab Diamond Upward Trend">
            </picture>
            <div class="press_left">
                <picture>
                    <source width="451" height="300" type="image/webp" srcset="~/assets/media/ibt.webp">
                    <img loading="lazy" class="radious_four" type="image/jpeg" src="~/assets/media/ibt.jpg" width="451" height="300"
                        alt="Sustainability At The Fore Of A Lab Diamond Upward Trend">
                </picture>
            </div>
            <div class="press_right">
                <div class="press_text">
                    <picture>
                        <source width="103" height="40" type="image/webp" srcset="~/assets/media/pr/ibt.webp">
                        <img class="for_desktop radious_four" loading="lazy" type="image/jpeg" width="103" height="40"
                            src="~/assets/media/pr/ibt.jpg"
                            alt="Sustainability At The Fore Of A Lab Diamond Upward Trend">
                    </picture>
                    <h2 class="font-active">Sustainability At The Fore Of A Lab Diamond Upward Trend</h2>
                    <p>Insights on the evolving trend of lab diamonds in the industry: Helping you embrace a better
                        tomorrow with conflict-free, sustainable & affordable alternatives. Say goodbye to mining and
                        hello to eco-friendly lab diamonds that inspire a brighter future.</p>
                    <a href="https://www.ibtimes.com/sustainability-fore-lab-diamond-upward-trend-3492644"
                        target="_blank" rel="nofollow noopener" class="radious_four">
                        read more
                    </a>
                </div>
            </div>
        </div>
        <div class="press_block radious_eight">
            <picture>
                <source width="332" height="40" type="image/webp" srcset="~/assets/media/pr/latin_times.webp">
                <img loading="lazy" width="332" height="40" class="for_mobile radious_four" type="image/jpeg"
                    src="~/assets/media/pr/latin_times.jpg" alt="Friendly Diamonds: Your Perfect Match">
            </picture>
            <div class="press_left">
                <picture>
                    <source width="451" height="300" type="image/webp" srcset="~/assets/media/latin_times.webp">
                    <img loading="lazy" class="radious_four" type="image/jpeg" src="~/assets/media/latin_times.jpg"
                        alt="Friendly Diamonds: Your Perfect Match" width="451" height="300">
                </picture>
            </div>
            <div class="press_right">
                <div class="press_text">
                    <picture>
                        <source width="332" height="40" type="image/webp" srcset="~/assets/media/pr/latin_times.webp">
                        <img class="for_desktop" loading="lazy" width="332" height="40" type="image/jpeg"
                            src="~/assets/media/pr/latin_times.jpg" alt="Friendly Diamonds: Your Perfect Match">
                    </picture>
                    <h2 class="font-active">Friendly Diamonds: Your Perfect Match</h2>
                    <p>A romantic tale of love forged in the halls of academia, and now sealed for eternity with a
                        stunning lab grown diamond ring. Indulge in the heartwarming journey of two souls as they
                        navigate life's highs and lows & make their way towards forever.</p>
                    <a href="https://www.latintimes.com/friendly-diamonds-your-perfect-match-514765" target="_blank"
                        rel="nofollow noopener" class="radious_four">
                        read more
                    </a>
                </div>
            </div>
        </div>
        <!-- <div class="press_block">
            <picture>
                <source width="140" height="40" type="image/webp" srcset="~/assets/media/pr/thevou.webp">
                <img class="for_mobile" loading="lazy" width="140" height="40" type="image/jpeg"
                    src="~/assets/media/pr/thevou.jpg"
                    alt="17 Trusted Online Stores For Engagement Rings (Rare, Unique, Affordable)">
            </picture>
            <div class="press_left">
                <picture>
                    <source width="451" height="300" type="image/webp" srcset="~/assets/media/the_vou.webp">
                    <img loading="lazy" type="image/jpeg" src="~/assets/media/the_vou.jpg" width="451" height="300"
                        alt="17 Trusted Online Stores For Engagement Rings (Rare, Unique, Affordable)">
                </picture>
            </div>
            <div class="press_right">
                <div class="press_text">
                    <picture>
                        <source width="140" height="40" type="image/webp" srcset="~/assets/media/pr/thevou.webp">
                        <img class="for_desktop" loading="lazy" width="140" height="40" type="image/jpeg"
                            src="~/assets/media/pr/thevou.jpg"
                            alt="17 Trusted Online Stores For Engagement Rings (Rare, Unique, Affordable)">
                    </picture>
                    <h2 class="font-active">17 Trusted Online Stores For Engagement Rings (Rare, Unique, Affordable)
                    </h2>
                    <p>Sustainability and customer-centricity put at the heart of our business. Discover our stunning
                        online collection of affordable and ethical engagement rings, where every purchase made
                        contributes in stepping towards a better world.</p>
                    <a href="https://thevou.com/fashion/engagement-rings/" target="_blank" rel="nofollow noopener">
                        read more
                    </a>
                </div>
            </div>
        </div> -->
        <div class="press_block radious_eight">
            <picture>
                <source width="193" height="140" type="image/webp" srcset="~/assets/media/pr/portland_monthly.webp">
                <img loading="lazy" class="for_mobile radious_four" width="193" height="140" type="image/jpeg"
                    src="~/assets/media/pr/portland_monthly.jpg" alt="Eco-Friendly Bridal Jewelry Trends This Season">
            </picture>
            <div class="press_left">
                <picture>
                    <source width="451" height="300" type="image/webp" srcset="~/assets/media/portland.webp">
                    <img loading="lazy" type="image/jpeg" class="radious_four" src="~/assets/media/portland.jpg" width="451" height="300"
                        alt="Eco-Friendly Bridal Jewelry Trends This Season">
                </picture>
            </div>
            <div class="press_right">
                <div class="press_text">
                    <picture>
                        <source width="193" height="140" type="image/webp"
                            srcset="~/assets/media/pr/portland_monthly.webp">
                        <img loading="lazy" class="for_desktop radious_four" width="193" height="140" type="image/jpeg"
                            src="~/assets/media/pr/portland_monthly.jpg"
                            alt="Eco-Friendly Bridal Jewelry Trends This Season">
                    </picture>
                    <h2 class="font-active">Eco-Friendly Bridal {{ $t('jewelry') }} Trends This Season</h2>
                    <p>Make your big day sparkle sustainably with stunning, eco-conscious fine diamond bridal {{
                        $t('jewelry') }}. Because your celebration deserves to be grand with all things dreamy: flower
                        crowns, sunshine & diamonds of course!</p>
                    <a href="https://www.pdxmonthly.com/sponsored/2022/04/friendly-diamonds-custom-engagement-rings-online"
                        target="_blank" rel="nofollow noopener" class="radious_four">
                        read more
                    </a>
                </div>
            </div>
        </div>

        <div class="press_block radious_eight">
            <picture>
                <source width="90" height="40" type="image/webp" srcset="~/assets/media/pr/wedding_forward.webp">
                <img class="for_mobile radious_four" loading="lazy" width="90" height="40" type="image/jpeg"
                    src="~/assets/media/pr/wedding_forward.jpg" alt="Bridal Sets: Stunning Rings For Perfect Wedding">
            </picture>
            <div class="press_left">
                <picture>
                    <source width="451" height="300" type="image/webp" srcset="~/assets/media/wedding_forward.webp">
                    <img loading="lazy" class="radious_four" type="image/jpeg" src="~/assets/media/wedding_forward.jpg" width="451"
                        height="300" alt="Bridal Sets: Stunning Rings For Perfect Wedding">
                </picture>
            </div>
            <div class="press_right">
                <div class="press_text">
                    <picture>
                        <source width="90" height="40" type="image/webp"
                            srcset="~/assets/media/pr/wedding_forward.webp">
                        <img class="for_desktop radious_four" loading="lazy" width="90" height="40" type="image/jpeg"
                            src="~/assets/media/pr/wedding_forward.jpg"
                            alt="Bridal Sets: Stunning Rings For Perfect Wedding">
                    </picture>
                    <h2 class="font-active">Bridal Sets: Stunning Rings For Perfect Wedding</h2>
                    <p>From adding classic elegance to modern flair, these bridal sets will make your special day truly
                        unforgettable. Make a lasting impression with a touch of sophistication that reflects your
                        unique style and personality.</p>
                    <a href="https://www.weddingforward.com/bridal-sets/" target="_blank" rel="nofollow noopener" class="radious_four">
                        read more
                    </a>
                </div>
            </div>
        </div>



        <div class="press_block radious_eight">
            <picture>
                <source width="202" height="40" type="image/webp" srcset="~/assets/media/pr/luxuo.webp">
                <img class="for_mobile radious_four" loading="lazy" width="202" height="40" type="image/jpeg"
                    src="~/assets/media/pr/luxuo.jpg" alt="A Friendly Approach To Diamond Engagement Rings">
            </picture>
            <div class="press_left">
                <picture>
                    <source width="451" height="300" type="image/webp" srcset="~/assets/media/luxuo.webp">
                    <img loading="lazy" class="radious_four" type="image/jpeg" src="~/assets/media/luxuo.jpg" width="451" height="300"
                        alt="A Friendly Approach To Diamond Engagement Rings">
                </picture>
            </div>
            <div class="press_right">
                <div class="press_text">
                    <picture>
                        <source width="202" height="40" type="image/webp" srcset="~/assets/media/pr/luxuo.webp">
                        <img class="for_desktop radious_four" loading="lazy" width="202" height="40" type="image/jpeg"
                            src="~/assets/media/pr/luxuo.jpg" alt="A Friendly Approach To Diamond Engagement Rings">
                    </picture>
                    <h2 class="font-active">A Friendly Approach To Diamond Engagement Rings</h2>
                    <p>Experience the captivating beauty of eco-friendly diamond engagement rings, expertly crafted to
                        add that luxurious touch to your looks. Revel in the brilliance of exquisite designs that
                        reflect your commitment to sustainability, and cherish the moment as you embark on a journey of
                        love and ethics.</p>
                    <a href="https://www.luxuo.com/style/jewelry/a-friendly-approach-to-diamond-engagement-rings.html"
                        target="_blank" rel="nofollow noopener" class="radious_four">
                        read more
                    </a>
                </div>
            </div>
        </div>
        <div class="press_block radious_eight">
            <picture>
                <source width="115" height="40" type="image/webp" srcset="~/assets/media/pr/wedding_chicks.webp">
                <img class="for_mobile radious_four" loading="lazy" width="115" height="40" type="image/jpeg"
                    src="~/assets/media/pr/wedding_chicks.jpg"
                    alt="How To Make Your Engagement Ring Selfie Total Perfection">
            </picture>
            <div class="press_left">
                <picture>
                    <source width="451" height="300" type="image/webp" srcset="~/assets/media/wedding_wire.webp">
                    <img loading="lazy" class="radious_four" type="image/jpeg" src="~/assets/media/wedding_wire.jpg" width="451" height="300"
                        alt="How To Make Your Engagement Ring Selfie Total Perfection">
                </picture>
            </div>
            <div class="press_right">
                <div class="press_text">
                    <picture>
                        <source width="115" height="40" type="image/webp"
                            srcset="~/assets/media/pr/wedding_chicks.webp">
                        <img loading="lazy" class="for_desktop radious_four" width="115" height="40" type="image/jpeg"
                            src="~/assets/media/pr/wedding_chicks.jpg"
                            alt="How To Make Your Engagement Ring Selfie Total Perfection">
                    </picture>
                    <h2 class="font-active">How To Make Your Engagement Ring Selfie Total Perfection</h2>
                    <p>Because clicking selfies is a thing now: Step onto a journey of enchantment to immerse yourself
                        in the aesthetics of luxury. Explore all things dreamy, valuable, and worth treasuring on the
                        go!</p>
                    <a href="https://www.weddingchicks.com/blog/how-to-make-your-engagement-ring-selfie-total-perfection-l-20099-l-47.html"
                        target="_blank" rel="nofollow noopener" class="radious_four">
                        read more
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
useFetchMeta( useNuxtApp(), useRuntimeConfig() );
</script>

<style scoped>
.press_block {
    padding: 25px;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
    display: flex;
    align-items: center;
    margin-bottom: 3%;
}

.press_left {
    width: 30%;
}

.press_right {
    width: 70%;
    padding-left: 4%;
}

h2 {
    font-size: 24px;
}

p {
    font-size: 16px;
    color: #6a6161;
}

a {
    display: inline-block;
    text-transform: uppercase;
    border: 1px solid var(--green);
    padding: 7px 15px;
    font-size: 14px;
    min-width: 150px;
    text-align: center;
    color: var(--green);
}

a:hover {
    color: #465f5a;
}

.press_right img {
    margin-bottom: 15px;
}

@media(max-width: 992px) {
    h1 {
        font-size: 32px;
    }

    .press_left {
        width: 40%;
    }

    .press_right {
        width: 60%;
    }

    h2 {
        font-size: 22px;
    }

    p {
        font-size: 14px;
    }

    a {
        padding: 6px 12px;
        min-width: 130px;
    }
}

@media(max-width: 767px) {
    .press_left img {
        margin-top: 20px;
    }

    h1 {
        text-align: center;
    }

    .press_block {
        flex-wrap: wrap;
        padding: 15px;
    }

    .press_left {
        width: 100%;
        display: flex;
        justify-content: center;
    }

    .press_right {
        width: 100%;
        padding-left: 0;
    }

    h2 {
        font-size: 18px;
        margin-top: 18px;
        line-height: 1.5;
    }
}
</style>
